import { SimpleGrid, Text, TextInput } from '@mantine/core';
import { useEmployeeFormContext } from '../NewEmployeePage';

export const FamilyContactCard: React.FC = () => {
  const form = useEmployeeFormContext();
  return (
    <div>
      <Text fw={700} size="lg" mt="lg">
        Kontakt na rodinu
      </Text>
      <SimpleGrid cols={2}>
        <TextInput
          required
          mt="sm"
          variant="filled"
          radius="md"
          placeholder="jméno"
          label="Jméno"
          {...form.getInputProps(`contacts.0.firstName`)}
        />

        <TextInput
          required
          mt="sm"
          variant="filled"
          radius="md"
          placeholder="příjmení"
          label="Příjmení"
          {...form.getInputProps(`contacts.0.lastName`)}
        />
      </SimpleGrid>
      <SimpleGrid cols={2}>
        <TextInput
          required
          mt="sm"
          variant="filled"
          radius="md"
          placeholder="telefon"
          label="Telefon"
          {...form.getInputProps(`contacts.0.phone`)}
        />

        <TextInput
          required
          mt="sm"
          variant="filled"
          radius="md"
          placeholder="e-mail"
          label="E-mail"
          {...form.getInputProps(`contacts.0.email`)}
        />
      </SimpleGrid>
      <TextInput
        required
        mt="sm"
        variant="filled"
        radius="md"
        placeholder="rodinný vztah"
        label="Rodinný vztah"
        {...form.getInputProps(`contacts.0.relation`)}
      />
    </div>
  );
};
